import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from '../../services/api.service';
import { UiModeService } from '../../services/ui-mode.service';

@Component({
  selector: 'app-promotion-v2',
  templateUrl: './promotion-v2.component.html'
})
export class PromotionV2Component implements OnInit {
  public imageURL: string = 'https://keongkee.com.my/api/public/static';
  public defaultImage: string = 'https://keongkee.com.my/api/public/static/default.jpeg';

  shop: string;
  promotions: Array<any> = [];
  loading = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private uiMode: UiModeService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.uiMode.scrollToTop();
      this.shop = params.shop || this.uiMode.shopFromHost();
      this.fetch();
    });
  }

  fetch() {
    this.loading = true;
    this.apiService.fetchPromotion(this.shop).subscribe(
      (data: Array<any>) => {
        this.promotions = (data || []).filter(p => p.active !== false);
        this.loading = false;
      },
      () => {
        this.promotions = [];
        this.loading = false;
      }
    );
  }

  goMenu() {
    this.router.navigate(['/v2/menu'], { queryParams: { shop: this.shop } });
  }

  onImgError(event) {
    event.target.src = this.defaultImage;
  }
}
